import useFetchData from "../../utils/hooks/useFetchData";
import Spinner from "../Global/Spinner";
import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import { SensorsWidget } from "../Widgets/SensorsWidget";
import { SimpleAreaWidget } from "../Widgets/SimpleAreaWidget";
import { SimpleBarWidget } from "../Widgets/SimpleBarWidget";
import { SimplePieChartWithPaddingAngleWidget } from "../Widgets/SimplePieChartWithPaddingAngleWidget";
import { TextWidget } from "../Widgets/TextWidget";
import { GaugeChartWidget } from "../Widgets/GaugeChartWidget";
import { HrHorizontal } from "../Global/HrHorizontal";
import { HrVertical } from "../Global/HrVertical";
import { Card } from "antd";

export const GreenSpaces = () => {
  const { data: greenSpacesData } = useFetchData("/nova_wallboards/getgreenspacesdata");

  if (greenSpacesData) {

    return (
      <>
        <div style={{ width: '33.3%' }}>
          <Card.Grid style={{ width: '100%', textAlign: 'center', height: '39%', padding: '5px' }}>
            <PrioritiesIncidents data={{
              red: greenSpacesData?.incidents.red,
              orange: greenSpacesData?.incidents.orange,
              yellow: greenSpacesData?.incidents.yellow,
            }} />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', height: '56%', padding: '5px' }}>
            <SimplePieChartWithPaddingAngleWidget
              label="EFICIÊNCIA DA REGA"
              value={greenSpacesData.wateringEfficincy} />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '18%', padding: '5px' }}>
            <TextWidget
              number={greenSpacesData.totalWeekEPALAndMINA}
              unit="m³"
              unitMesure="/semana"
              label="CONSUMO DE ÁGUA DA MINA E EPAL" />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '45%', padding: '5px' }}>
            <SimpleAreaWidget
              label="CONSUMO DE ÁGUA DE REGA  (m³)"
              data={greenSpacesData.wateringWeek}
              marginTop='0px'
              name='m³' />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '28%', padding: '5px' }}>
            <SimpleBarWidget
              data={greenSpacesData.weekEPALAndMinaHorizontalBarChart}
              layou='vertical'
              label="CONSUMO DA MINA E EPAL (m³)"
              height="100%"
              name='m³' />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <div style={{ display: "flex", width: '100%', height: '18%' }}>
            <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '5px' }}>
              <TextWidget
                label="CAUDAL EPAL"
                // reverse={true}
                number={greenSpacesData.caudaEPAL}
                unit="m³/h"
                margin='0'
              />
              <TextWidget
                label="CAUDAL MINA"
                // reverse={true}
                number={greenSpacesData.caudalMINA}
                unit="m³/h"
                margin='0'
              />
            </Card.Grid>
          </div>
          <HrHorizontal width="70%" marginTop='10px' />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '20%', padding: '5px' }}>
            <GaugeChartWidget label="PRESSÃO BOMBA"
              // reverse={true}
              value={greenSpacesData.bomPressure}
              unit="bar"
              margin='0'
              colors={["#ffc000", "#7a9767", "#ffc000"]}
              nrOfLevels={3}
              arcsLength={[2, 6, 2]} />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '44%', padding: '5px' }}>
            <SensorsWidget data={greenSpacesData.activeSensors} />
          </Card.Grid>
        </div>
      </>
    );
  } else {
    return (
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }
};
